import { Line } from 'vue-chartjs';
import ChartAnnotationsPlugin from 'chartjs-plugin-annotation';
// import { generateChart } from 'vue-chartjs';
// const CustomLine = generateChart('custom-line', 'line');

//setting chart-id as a prop does something...

export default {
    extends: Line,
    name: 'TimeChart',

    props: {
        chartdata: {
            type: Object,
            default: null
        },
        options: {
            type: Object,
            default: null
        },
        "chart-id": {
            type: String,
            default: "line-chart-dbcsi"
        }
        
    },
    mounted () {
        // console.log('TC: mounted')
        this.addPlugin(ChartAnnotationsPlugin);
        
        var newOptions = JSON.parse(JSON.stringify(this.options));
        this.renderChart (this.chartdata, newOptions);
        

 // https://stackoverflow.com/questions/64878459/annotation-dont-show-in-vue-chartjs/66058308#66058308
        // this.renderChart (this.chartdata, {...this.options,
        //   annotation: Object.assign({}, this.options.annotation) });
    },
    beforeUpdate () {
        console.log('TimeChart.js: beforeUpdate');
//         this.addPlugin(ChartAnnotationsPlugin);
        

//  // https://stackoverflow.com/questions/64878459/annotation-dont-show-in-vue-chartjs/66058308#66058308
//         this.renderChart (this.chartdata, {...this.options,
//           annotation: Object.assign({}, this.options.annotation) });
    }
};
